export default __webpack_public_path__ + "static/media/valleyPort5.024b1ff3.png";